export class RepresentativePoliticallyExposed {
    constructor() {}

    socialNumber?: string;

    name?: string;

    qualification?: string;

    relationship?: number;
}
